export default __webpack_public_path__ + "static/media/FilterIcon.18d97e85.svg";